import React from 'react';
import { Filter, X } from 'lucide-react';

// date_range values the backend accepts (DATE_RANGES in transforms.py).
export const DATE_RANGES = [
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
  { value: '365d', label: 'Last year' },
];

const select =
  'max-w-[11rem] truncate rounded-lg border border-zinc-700 bg-zinc-950 px-2 py-1 text-xs text-zinc-200 focus:border-[#5652CF] focus:outline-none disabled:opacity-50';

/** The dashboard's filter bar: every control narrows all widgets at once.
 * `options` = { [filterId]: values } from the data response; `values` = the
 * current choices ('' = all). A select with no options yet is hidden. */
const FilterBar = ({ filters, options, values, onChange, disabled }) => {
  const shown = (filters || []).filter(
    (f) => f.kind === 'date_range' || options?.[f.id]?.length,
  );
  if (!shown.length) return null;
  const active = Object.values(values).some(Boolean);
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-zinc-800 px-4 py-2">
      <Filter size={13} className="text-zinc-500" aria-hidden="true" />
      {shown.map((f) => (
        <label key={f.id} className="flex items-center gap-1.5">
          <span className="text-[11px] text-zinc-500">{f.label}</span>
          <select
            aria-label={f.label}
            value={values[f.id] || ''}
            disabled={disabled}
            onChange={(e) => onChange({ ...values, [f.id]: e.target.value })}
            className={select}
          >
            <option value="">All</option>
            {f.kind === 'date_range'
              ? DATE_RANGES.map((r) => (
                  <option key={r.value} value={r.value}>
                    {r.label}
                  </option>
                ))
              : options[f.id].map((v) => (
                  <option key={v} value={v}>
                    {v}
                  </option>
                ))}
          </select>
        </label>
      ))}
      {active && (
        <button
          onClick={() => onChange({})}
          disabled={disabled}
          className="flex items-center gap-1 rounded-md px-1.5 py-1 text-[11px] text-zinc-400 hover:bg-zinc-800"
        >
          <X size={12} aria-hidden="true" />
          Clear
        </button>
      )}
    </div>
  );
};

export default FilterBar;
